import { Outlet } from 'react-router-dom';
import { BrandMark } from '@/components/marketing/BrandMark';
import { ThemeToggle } from '@/components/marketing/ThemeToggle';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <header className="flex items-center justify-between border-b border-border/60 px-6 py-4">
        <BrandMark />
        <ThemeToggle />
      </header>
      <main className="flex flex-1 items-center justify-center p-6">
        <Outlet />
      </main>
    </div>
  );
}
